import { Dispatch } from '../components/architecture/frontend/index'
import {startWith, switchMap, map } from 'rxjs/operators'
import _ from 'lodash'

Dispatch.getAction('view')
  .pipe(
    switchMap(e => Dispatch.getAction('table.sortBy')
      .pipe(
        startWith({field: 'id', order: 'desc'})
      )
    )
  )
  .subscribe(e => Dispatch.nextState('table', { sortBy: e }))

Dispatch.getAction('table.checkbox.onchange')
  .pipe(
    map(tableName => {
      const elements = document.getElementsByClassName(tableName)
      const checked = _.filter(elements, element => element.checked)
      return {
        tableName,
        ids: checked.map(check => parseInt(check.id))
      }
    })
  )
  .subscribe(e => {
    Dispatch.nextState('table.' + e.tableName + '.checked', e.ids)
  })